/** Consent URLs contain literal OAuth state/PKCE data; do not start recording
 * that document or transmit the request/authorization-code response to telemetry.
 * An SDK already recording before SPA navigation is a separate lifecycle concern.
 */
export const isOAuthConsentPath = (path: string) => /^\/oauth\/consent\/?$/.test(path);
export function isOAuthConsentRequest(url?: string) {
  try { return !!url && /\/api\/v\d+\/oauth\/authorize\/(?:consent|scopes)\/?$/.test(new URL(url, 'https://local.invalid').pathname); }
  catch { return false; }
}
